(function () {
  // ---- match variant from up to 2 options
  function findVariant(variants, selections) {
    return variants.find(v =>
      (!selections[0] || v.option1 === selections[0]) &&
      (!selections[1] || v.option2 === selections[1])
    );
  }

  // ---- toggle the variant selector panel
  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('.qa-toggle');
    if (!toggle) return;
    const form = toggle.closest('form.qa-form');
    const panel = form?.querySelector('.qa-choices');
    if (!panel) return;

    const isOpen = !panel.hasAttribute('hidden');
    panel.toggleAttribute('hidden', isOpen);
    toggle.setAttribute('aria-expanded', String(!isOpen));
    toggle.classList.toggle('is-open', !isOpen);
    if (!isOpen) panel.querySelector('select')?.focus();
  });

  // ---- when options change, resolve variant id + enable/disable button
  function onOptionChange(form) {
    const tpl = form.querySelector('.qa-variants-json');
    if (!tpl) return;
    let variants;
    try { variants = JSON.parse(tpl.innerHTML.trim()); } catch { return; }

    const selects = form.querySelectorAll('.qa-select, [data-option-position]');
    const sel = [null, null];
    selects.forEach((el) => {
      const pos = Number(el.getAttribute('data-option-position') || '1') - 1;
      sel[pos] = el.value;
    });

    const variant = findVariant(variants, sel);
    const idInput = form.querySelector('input[name="id"]');
    if (variant && idInput) idInput.value = variant.id;

    const btn = form.querySelector('.qa-submit') || form.querySelector('.qa-btn');
    if (!btn) return;
    if (!variant) { btn.disabled = true; btn.textContent = 'Unavailable'; }
    else if (variant.available) { btn.disabled = false; btn.textContent = 'Add to Cart'; }
    else { btn.disabled = true; btn.textContent = 'Sold Out'; }
  }

  document.addEventListener('change', (e) => {
    const sel = e.target.closest('.qa-select, [data-option-position]');
    if (!sel) return;
    const form = sel.closest('form.qa-form');
    if (form && form.hasAttribute('data-has-variants')) onOptionChange(form);
  });

  // ---- add to cart via AJAX, then trigger theme's native drawer flow
  async function addToCart(form, btn) {
    const fd = new FormData(form);
    const original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: fd
      });
      if (!res.ok) throw new Error('Add failed');
      const added = await res.json();

      // Tell Motion to rebuild cart + open the drawer (exactly like PDP)
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { added } }));
      // Optional nudge (harmless if not used):
      document.dispatchEvent(new CustomEvent('cart:open'));

      btn.textContent = 'Added ✓';
    } catch (err) {
      console.error(err);
      btn.textContent = 'View cart';
      btn.addEventListener('click', () => (window.location.href = '/cart'), { once: true });
    } finally {
      setTimeout(() => { btn.textContent = original; btn.disabled = false; }, 1000);
    }
  }

  // ---- intercept our quick-add forms
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form.qa-form[data-ajax-qa]');
    if (!form) return;
    e.preventDefault();

    if (form.hasAttribute('data-has-variants')) onOptionChange(form);
    const btn = form.querySelector('.qa-submit') || form.querySelector('.qa-btn');
    const variantId = form.querySelector('input[name="id"]')?.value;
    if (!btn || !variantId) return;

    addToCart(form, btn);
  });

  // ---- initialize buttons on load
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('form.qa-form[data-has-variants]').forEach(onOptionChange);
  });
})();
